module.exports = __webpack_public_path__ + "c805fa503b584c043b8704a1f25b18b2.png";